/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import Carousel from '@brainhubeu/react-carousel';
import { withRouter } from 'react-router-dom'

// REDUX
import { connect } from 'react-redux';
import styles from './ContentCardCarousel.module.css';
import * as contentCardConstants from "../../../shared/constants/contentCards";
import { filterContentCards } from "../../../shared/utilities/braze";
import HeroPromoContentCardTemplate from "./Templates/HeroBanner/HeroPromoContentCardTemplate";
import HeroPromoText from "./Templates/HeroPromoText/HeroPromoText";
import { routeCountryPath } from '../../../shared/utilities/common';
import HeroIntroPromo from './Templates/HeroIntroPromo/HeroIntroPromo';
import * as elementsActions from "../../../redux/actions/elements";
import elementConstant from "../../../shared/constants/element";
import { VIDEO_TYPES } from '../../../shared/constants/common';
import HeroPromoImage from './Templates/HeroPromoImage/HeroPromoImage';
import { trackContentCardImpression, trackContentCardClick } from "../../../shared/utilities/brazeTracking";

class ContentCardCarousel extends Component {
  intervalResult = null;

  constructor(props) {
    super(props);

    this.state = {
      cardData: [],
      initialized: false,
      carouselIndex: 0,
      animationKey: Date.now(),
      isHovered: false
    };

    this.animationTimer = null;
    this.remainingTime = 0;
    this.timerStarted = false;
    this.tablistRef = React.createRef();

    this.setSlideIndex = this.setSlideIndex.bind(this);
  }

  componentDidMount() {
    const { delay } = this.props;
    setTimeout(() => {
      this.initializeCarousel();
    }, delay);
  }

  componentDidUpdate(prevProps) {
    const { contentCards } = this.props;
    const { contentCards: prevContentCards } = prevProps;
    
    // Reinitialize when contentCards changes from null/undefined to actual data
    if (prevContentCards === null && contentCards !== null) {
      this.clearAnimationTimer();
      this.initializeCarousel();
    }
    // Also reinitialize if contentCards data changed
    if (prevContentCards !== contentCards && contentCards !== null) {
      this.clearAnimationTimer();
      this.initializeCarousel();
    }
  }

  initializeCarousel = () => {
    const {
      selectedStore,
      templates,
      contentCards,
      defaultHeroBanner
    } = this.props;
    const { initialized } = this.state;
    const storeId =
      selectedStore?.id !== undefined ? parseInt(selectedStore?.id, 10) : null;
    
    // If contentCards is null but we have a defaultHeroBanner, we can still show that
    // This handles the initial load case when Braze data hasn't arrived yet
    if (contentCards === null) {
      // Only set initialized if we have a defaultHeroBanner to show
      if (defaultHeroBanner && !initialized) {
        this.setState({
          cardData: [defaultHeroBanner],
          initialized: true
        });
      }
      return;
    }
    
    // Always reinitialize and update cardData when we have contentCards
    // This ensures the carousel updates when Braze data arrives after initial load
    const filteredCards = filterContentCards(contentCards, templates, storeId, window.location.href);
    const usingFilteredCards = filteredCards.length > 0;
    const cardData =
      usingFilteredCards ? filteredCards : [defaultHeroBanner];
    
    // TODO: TEMPORARY FIX - Rename #boxes to #packs in banner URLs
    // Remove this after the site setting has been updated with correct URL
    const updatedCardData = cardData.map(card => {
      if (card && card.url === '#boxes') {
        return { ...card, url: '#packs' };
      } if (card && (card.extras?.desktopVideoUrl || card.extras?.mobileVideoUrl)) {
        const desktopVideoUrl = this.translateAdminLinksToCdn(card.extras?.desktopVideoUrl);
        const mobileVideoUrl = this.translateAdminLinksToCdn(card.extras?.mobileVideoUrl);

        return { ...card, extras: { ...card.extras, desktopVideoUrl, mobileVideoUrl } };
      }

      return card;
    });

    this.setState({
      cardData: updatedCardData,
      initialized: true
    }, () => {
      // Start timer after state is updated, only if there are multiple slides
      if (updatedCardData.length > 1) {
        this.startAnimationTimer();
      }
    });

    // Reset timer flag when carousel is reinitialized
    this.timerStarted = false;
  };

  clearCarouselInterval = () => {
    window.clearInterval(this.intervalResult);
  };

  clearAnimationTimer = () => {
    if (this.animationTimer) {
      clearTimeout(this.animationTimer);
      this.animationTimer = null;
    }
  };

  startAnimationTimer = () => {
    const { carouselSpeed } = this.props;
    this.remainingTime = carouselSpeed;

    this.animationTimer = setTimeout(() => {
      this.handleAnimationComplete();
    }, this.remainingTime);
  };

  handleAnimationComplete = () => {
    const { cardData, carouselIndex, isHovered } = this.state;

    // Only advance if not hovered
    if (!isHovered) {
      const isLastCard = cardData.length - 1 === carouselIndex;
      const newSlideIndex = isLastCard ? 0 : carouselIndex + 1;
      this.setSlideIndex(newSlideIndex);
    }
  };

  initializeCarouselInterval = () => {
    this.clearCarouselInterval();
    // Animation will handle the slide advancement now
  };


  handleMouseEnter = () => {
    this.setState({ isHovered: true });

    // Pause the animation timer
    if (this.animationTimer) {
      clearTimeout(this.animationTimer);
      this.animationTimer = null;
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });

    // Resume the animation timer
    this.startAnimationTimer();
  };

  setSlideIndex = carouselIndex => {
    this.clearAnimationTimer();
    this.setState({
      carouselIndex,
      animationKey: Date.now()
    });

    // Start animation timer
    this.startAnimationTimer();
    const {setCarouselSpeed} = this.props;
    const { cardData } = this.state;

    const card = cardData[carouselIndex];
    if (card) {
      const isVideoTemplate = VIDEO_TYPES.includes(card?.extras?.mime);
      if (isVideoTemplate){
        let videos = document.getElementsByTagName('video')
        const { desktopVideoUrl, mobileVideoUrl } = card?.extras;
        if(videos.length > 0){
          videos = [...videos];

          const videoFile = window.innerWidth <= elementConstant.introHeroBannerWidthThreshold
                ? mobileVideoUrl
                : desktopVideoUrl;
          let matchingVideoFound = false;

          videos.forEach(video => {
            const sourceEl = video.children[0];
            if (!sourceEl || !videoFile) {
              return;
            }
            if(sourceEl.src  === videoFile) {
              matchingVideoFound = true;
              const carouselSpeed = parseInt(video.duration * 1000, 10);
              video.load();
              setCarouselSpeed(carouselSpeed)
            }
          });
          if (!matchingVideoFound) {
            setCarouselSpeed(contentCardConstants.CAROUSEL_SPEED);
          }
        }
      } else {
        setCarouselSpeed(contentCardConstants.CAROUSEL_SPEED)
      }
      // Track impression
      trackContentCardImpression(card);
    }
  };

  handleClick = () => {
    const { cardData, carouselIndex } = this.state;
    const { history } = this.props;

    const card = cardData[carouselIndex];

    if (card) {
      // Track click
      trackContentCardClick(card);

      const isExternal = card.url.startsWith(
        contentCardConstants.EXTERNAL_URL_PREFIX
      );
      if (isExternal) {
        window.open(card.url);
      } else {
        history.push(routeCountryPath(card.url));
      }
    }
  };

  selectCard = (index, shouldFocus = false) => {
    this.setSlideIndex(index);
    this.initializeCarouselInterval();
    
    // Focus the selected tab button if requested (for keyboard navigation)
    if (shouldFocus && this.tablistRef.current) {
      setTimeout(() => {
        const buttons = this.tablistRef.current.querySelectorAll('button[role="tab"]');
        if (buttons[index]) {
          buttons[index].focus();
        }
      }, 0);
    }
  };

  getTemplateName = (card, templates) => {
    const hasTemplateExists = templates.includes(card?.extras?.template);
    if (!hasTemplateExists) {
      return false;
    }

    let template = null;

    // eslint-disable-next-line default-case
    switch (card?.extras?.template) {
      case contentCardConstants.HERO_PROMO_TEMPLATE:
        template = HeroPromoContentCardTemplate;
        break;
      case contentCardConstants.HERO_PROMO_TEXT_TEMPLATE:
        template = HeroPromoText;
        break;
      case contentCardConstants.HERO_PROMO_IMAGE_TEMPLATE:
        template = HeroPromoImage;
        break;
      case contentCardConstants.HERO_INTRO_PROMO_TEMPLATE:
        template = HeroIntroPromo;
        break;
    }
    return template;
  };

  translateAdminLinksToCdn = (url) => {
    const { brazeContentCardLink, brazeContentCardLinkReplaceWith } = this.props;
    if (url && brazeContentCardLink && brazeContentCardLinkReplaceWith) {
      return url.replace(brazeContentCardLink, brazeContentCardLinkReplaceWith);
    }
    return url;
  };

  renderCarouselContainer = () => {
    const { cardData, carouselIndex, animationKey, isHovered } = this.state;

    const { openDeliveryWidget, isContentCardFullWidth, carouselSpeed } = this.props;

    const { templates, carouselControlStyles } = this.props;

    if (!cardData.length) {
      return null;
    }

    // Check if the current carousel contains HeroIntroPromo template
    const hasHeroIntroPromo = cardData.some(card => card?.extras?.template === contentCardConstants.HERO_INTRO_PROMO_TEMPLATE);
    
    // Apply leftCenter class for full-width content cards
    const dotsClass = isContentCardFullWidth ? styles.leftCenter : '';

    const dots =
      cardData.length > 1 ? (
        <div 
          ref={this.tablistRef}
          className={`${hasHeroIntroPromo ? '' : carouselControlStyles.cardDots} ${dotsClass}`}
          role="tablist"
          aria-label="Carousel slide controls"
        >
          {cardData.map((card, cardIndex) => {
            const isSelected = cardIndex === carouselIndex;
            const className = isSelected ? `${styles.selectedIndex} ${isHovered ? styles.hovered : ''}` : null;

            const animationStyle = isSelected ? {
              '--animation-duration': `${carouselSpeed}ms`,
              '--animation-play-state': isHovered ? 'paused' : 'running'
            } : {};

            return (
              <button
                key={`${cardIndex}-${animationKey}`} // eslint-disable-line
                type="button"
                role="tab"
                onClick={() => this.selectCard(cardIndex)}
                tabIndex={isSelected ? 0 : -1}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.selectCard(cardIndex);
                  } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    const nextIndex = cardIndex < cardData.length - 1 ? cardIndex + 1 : 0;
                    this.selectCard(nextIndex, true);
                  } else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    const prevIndex = cardIndex > 0 ? cardIndex - 1 : cardData.length - 1;
                    this.selectCard(prevIndex, true);
                  }
                }}
                className={className}
                style={animationStyle}
                aria-label={`Slide ${cardIndex + 1} of ${cardData.length}`}
                aria-selected={isSelected}
              />
            );
          })}
        </div>
      ) : null;

    return (
      <div
        className={`${styles.carouselContainer} w-full flex flex-col items-center`}
      >
        <div
          className={`${styles.cardContainer} ${isHovered ? styles.hovered : ''} w-full ${!isContentCardFullWidth ? 'shadow-md rounded-[30px]' :''}`}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <Carousel value={carouselIndex} onChange={this.setSlideIndex} draggable={false}>
            {cardData.map((card, cardIndex) => {
              const TemplateName = this.getTemplateName(card, templates);
              const isActive = cardIndex === carouselIndex;
              
              return (
                <TemplateName
                  key={card.id || cardIndex}
                  cardData={card}
                  openDeliveryWidget={openDeliveryWidget}
                  isActive={isActive}
                />
              );
            })}
          </Carousel>
        </div>
        {/* Render dots with HeroIntroPromo container structure */}
        {hasHeroIntroPromo && (
          <div className={styles.dotsOuterWrapper}>
            <div className={styles.dotsInnerWrapper}>
              <div className={styles.dotsContainer}>
                {dots}
              </div>
            </div>
          </div>
        )}
        {/* Render dots normally for other templates */}
        {!hasHeroIntroPromo && dots}
      </div>
    );
  };

  render() {
    const { initialized } = this.state;

    if (!initialized) {
      return null;
    }

    return <this.renderCarouselContainer />;
  }
}

ContentCardCarousel.propTypes = {
  selectedStore: PropTypes.shape(
    {
      id: PropTypes.oneOfType(
        [
          PropTypes.number,
          PropTypes.string
        ]
      )
    }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  templates: PropTypes.arrayOf(PropTypes.string),
  carouselControlStyles: PropTypes.shape(PropTypes.object),
  contentCards: PropTypes.shape(PropTypes.object),
  defaultHeroBanner: PropTypes.shape(PropTypes.object).isRequired,
  carouselSpeed: PropTypes.number.isRequired,
  delay: PropTypes.number,
  openDeliveryWidget: PropTypes.func,
  setCarouselSpeed: PropTypes.func.isRequired,
  isContentCardFullWidth: PropTypes.bool,
  brazeContentCardLink: PropTypes.string,
  brazeContentCardLinkReplaceWith: PropTypes.string,
}

ContentCardCarousel.defaultProps = {
  selectedStore: {
    id: null
  },
  templates: [],
  carouselControlStyles: {},
  contentCards: null,
  delay: 0,
  openDeliveryWidget: null,
  isContentCardFullWidth: false,
  brazeContentCardLink: null,
  brazeContentCardLinkReplaceWith: null,
}

export const mapStateToProps = (state) => {
  const { selectedStore } = state.user;
  const { contentCards, defaultHeroBanner } = state.braze;
  const { carouselSpeed, isContentCardFullWidth } = state.elements;
  const { brazeContentCardLink, brazeContentCardLinkReplaceWith } = state.braze;

  return {
    contentCards,
    selectedStore,
    defaultHeroBanner,
    carouselSpeed,
    isContentCardFullWidth,
    brazeContentCardLink,
    brazeContentCardLinkReplaceWith,
  };
}

export const mapDispatchToProps = (dispatch) => {
  const setCarouselSpeed = (value) =>
    dispatch(elementsActions.setCarouselSpeed(value));

  return {setCarouselSpeed}
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ContentCardCarousel));
